import React from "react";
import {
  InputGroup,
  FormGroup,
  HTMLSelect,
  Dialog,
  Classes,
  Intent,
  Button
} from "@blueprintjs/core";

class DialogAddFeedback extends React.Component {
  render() {
    const {
      feedback,
      dialogIsOpen,
      onCloseDialog,
      onChangeInput,
      onAddFeedback
    } = this.props;

    return (
      <Dialog
        icon="add"
        title="Add Feedback"
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        usePortal={true}
        enforceFocus={true}
        isOpen={dialogIsOpen}
        onClose={onCloseDialog}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup label="Feedback type" labelFor="feedback-type">
            <HTMLSelect
              id="feedback-type"
              fill={true}
              name="type"
              defaultValue={feedback.type || "UNK"}
              onChange={onChangeInput}
            >
              <option disabled value="UNK">
                Choose type
              </option>
              <option value="OPEN">Open</option>
              <option value="CLOSE">Closed</option>
            </HTMLSelect>
          </FormGroup>
          <FormGroup label="Question" labelFor="feedback-question">
            <InputGroup
              id="feedback-question"
              name="question"
              disabled={feedback.type === "UNK" || feedback.type == null}
              onChange={onChangeInput}
            />
          </FormGroup>
          <FormGroup
            label="Legend on the left (15 characters max.)"
            labelFor="feedback-left-legend"
          >
            <InputGroup
              id="feedback-left-legend"
              name="leftLegend"
              disabled={!(feedback.type === "CLOSE")}
              maxLength={15}
              onChange={onChangeInput}
            />
          </FormGroup>
          <FormGroup
            label="Legend on the right (15 characters max.)"
            labelFor="feedback-right-legend"
          >
            <InputGroup
              id="feedback-right-legend"
              name="rightLegend"
              disabled={!(feedback.type === "CLOSE")}
              maxLength={15}
              onChange={onChangeInput}
            />
          </FormGroup>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={onCloseDialog} text="Cancel" />
            <Button
              onClick={onAddFeedback}
              text="Add"
              disabled={
                feedback.type == null ||
                feedback.type === "UNK" ||
                feedback.question == null ||
                feedback.question.length === 0
              }
              intent={Intent.SUCCESS}
              rightIcon="add"
            />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default DialogAddFeedback;
